import React from "react";
import styles from "./Features.module.css";
import featureInfo1 from "../../assets/images/featureInfo1.jpg";
import featureInfo2 from "../../assets/images/featureInfo2.jpg";
import featureInfo3 from "../../assets/images/featureInfo3.jpg";
import featureInfo4 from "../../assets/images/featureInfo4.jpg";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
const Features = () => {
  return (
    <>
      <Header />
      <div>
        <div className={styles.feature_banner}>
          <h3>What is “My Ace”</h3>
          <h6>　マイエースでできること</h6>
        </div>
        <div className={`container ${styles.feature_info}`}>
          <div className={`d-flex mb-5 ${styles.feature_info_details1}`}>
            <div>
              <img src={featureInfo1} alt="" />
            </div>
            <div className={` ml-4 mt-2 ${styles.details_text}`}>
              <h5>1．撮影した日にPCやスマホに写真をダウンロードできる</h5>
              <h6>
                エーススタジオで撮影した画像データをMy
                Aceからダウンロードすることが 可能です。
                <br />
                PCやスマホに一括でダウンロードできるから、いつでもお気に入りの写真を見ることができます。
              </h6>
              <h6 className="mt-4">
                ＊ダウンロードの有効期限は3ヶ月です。 <br />
                ＊出張プランやムービーは編集に数日お時間をいただきます。
              </h6>
            </div>
          </div>

          <div className={`d-flex mb-5 ${styles.feature_info_details1}`}>
            <div className={` mt-2 ${styles.details_text}`}>
              <h5>2．24時間365日、いつでも写真のセレクトや編集が可能</h5>
              <h6 className="pr-3">
                ご家族でゆっくり１枚１枚写真を見ながら、ご購入いただいたオプシ
                ョングッズのお写真をセレクトしていただけます。
                <br />
                また、アイテムグッズのトリミング編集や文字入れのご希望をオンライン上で
                行うことが可能です。時間を気にすることなく、ライフスタイルに合わせて
                セレクトをお楽しみください。
              </h6>
            </div>
            <div>
              <img src={featureInfo2} alt="" />
            </div>
          </div>

          <div className={`d-flex mb-5 ${styles.feature_info_details1}`}>
            <div>
              <img src={featureInfo3} alt="" />
            </div>
            <div className={` ml-4 mt-1 ${styles.details_text}`}>
              <h5>３．アイテムグッズをオンラインで購入可能！</h5>
              <h6>
                一瞬の表情やその時の思いを未来へと残すことができるよう、幅広い商品を取
                り揃えています。
                <br />
                オンラインでもご購入いただけますので、迷っていた商品をじっくり見て決め
                たり、お気に入りの商品を追加で購入したりと、好きな時間にお買い物をお楽
                しみください。
                遠方のおじいちゃん・おばあちゃんへのギフトとしてお届けす
                る事も可能です。
              </h6>
            </div>
          </div>

          <div className={`d-flex mb-5 ${styles.feature_info_details1}`}>
            <div className={` mt-2 ${styles.details_text}`}>
              <h5 className="mt-4">
                ４．Acestudioでの撮影データを長期保管できる
              </h5>
              <h6>
                エーススタジオで撮影した画像データをMy
                Aceからダウンロードすることが <br />
                可能です。
                <br />
                PCやスマホに一括でダウンロードできるから、いつでもお気に入りの写真を見ることができます。
              </h6>
            </div>
            <div>
              <img src={featureInfo4} alt="" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Features;
